import http from "axios";
import { ElNotification } from "element-plus";

http.interceptors.request.use(
  (config) => {
    const user = sessionStorage.getItem("user");
    let apiToken = localStorage.getItem("api_token");

    if (user) {
      const parsedUser = JSON.parse(user);
      apiToken = parsedUser.api_token || apiToken;
    }

    if (apiToken) {
      config.headers["api-token"] = `${apiToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error?.response || error)
);

http.interceptors.response.use(
  (response) => {
    const { code, message } = response.data || {};

    if (code) {
      ElNotification({
        title: "Error",
        message: message || "请求失败",
        type: "error",
      });
      return Promise.reject(response);
    }

    if (response.config.method !== "get" && message) {
      ElNotification({
        title: "Success",
        message,
        type: "success",
      });
    }

    return response.data;
  },
  (error) => {
    const response = error?.response || error;
    let message = null;

    if (response?.status) {
      switch (response.status) {
        case 400:
          message = response.data?.msg || response.data?.message || "请求参数错误";
          break;
        case 401:
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("user");
          localStorage.removeItem("api_token");
          window.dispatchEvent(new CustomEvent("auth-expired"));
          message = "登录已过期，请重新登记后继续操作";
          break;
        case 404:
          message = "接口地址不存在";
          break;
        case 405:
          message = `接口请求方式 ${response.config?.method} 不支持`;
          break;
        case 422:
          message = "数据验证失败";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        default:
          message = response.data?.message || "请求失败";
      }
    }

    if (message) {
      ElNotification({
        title: "Error",
        message,
        type: "error",
      });
    }

    return Promise.reject(response);
  }
);

export default http;
